.getInTouchModal {
  > .content {
    @media (min-width: 769px) {
      max-width: 33rem;
    }
  }

  .success {
    max-width: 27rem;
    margin: 0 auto;
    text-align: center;
  }

  .description {
    max-width: 23.75rem;
    display: flex;
    flex-direction: column;
    margin: -0.125rem 0 1.375rem;

    @media (min-width: 400px) {
      max-width: unset;
    }
  }

  .email {
    margin: 1.125rem 0 0;
  }
}
